<template>
  <div class="calculator-tabs">
    <button
      type="button"
      class="tab-btn"
      :class="{ active: activeTab === 'condominio' }"
      data-type="condominio"
      @click="switchTab('condominio')"
    >
      {{ $t("tools.condominium") }}
    </button>
    <button
      type="button"
      class="tab-btn"
      :class="{ active: activeTab === 'empresa' }"
      data-type="empresa"
      @click="switchTab('empresa')"
    >
      {{ $t("tools.company") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "SimuladorTabs",
  props: {
    activeTab: {
      type: String,
      required: true
    }
  },
  methods: {
    switchTab(tab) {
      this.$emit("update:activeTab", tab);
    }
  }
};
</script>

<style scoped>
.calculator-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.tab-btn {
  padding: 12px 30px;
  border: 2px solid #f0512d;
  margin: 0 10px;
  cursor: pointer;
  border-radius: 30px;
  background-color: transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.tab-btn.active {
  background-color: #f0512d;
  color: white;
}
</style>
